import React from 'react';
import {NavLink} from 'react-router-dom';

const Cta3 = () => {
    return (
        <section className="cta-wrapper cta--three bgimage biz_overlay overlay--secondary2">
            <div className="bg_image_holder">
                <img src="./assets/img/sbg2.jpg" alt="" />
            </div>
            <div className="container content_above">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2">
                        <div className="cta-content text-center">
                            <p>A range of consulting and custom solutions that enable you.</p>
                            <NavLink to="/contact-us" className="btn btn-secondary">Contact Us</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Cta3;
